import Dexie from "dexie";
import db from "../Db";

var DeleteUtil = Dexie.async(function* () {
  yield db.open();
  yield db.UTIL.clear();
});

export default DeleteUtil;
